module.exports = __webpack_public_path__ + "static/media/lrp.bf45691e.jpg";